import { render, staticRenderFns } from "./about-section.vue?vue&type=template&id=d6170c50"
import script from "./about-section.vue?vue&type=script&lang=js"
export * from "./about-section.vue?vue&type=script&lang=js"
import style0 from "./about-section.vue?vue&type=style&index=0&id=d6170c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports